var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Promociones","size":"xl","hide-footer":"","id":"promociones-vinoteca"}},[_c('view-component',{attrs:{"solo_emitir_delete":"","model_name":"promocion_vinoteca"},on:{"press_delete_btn":_vm.press_delete_btn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }